/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateWochenplanZuordnungDto } from '../../models/create-wochenplan-zuordnung-dto';
import { KalendereintragDto } from '../../models/kalendereintrag-dto';

export interface CreateWochenplanZuordnungForMitarbeiter$Json$Params {
  mitarbeiterId: string;
      body?: CreateWochenplanZuordnungDto
}

export function createWochenplanZuordnungForMitarbeiter$Json(http: HttpClient, rootUrl: string, params: CreateWochenplanZuordnungForMitarbeiter$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KalendereintragDto>>> {
  const rb = new RequestBuilder(rootUrl, createWochenplanZuordnungForMitarbeiter$Json.PATH, 'post');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<KalendereintragDto>>;
    })
  );
}

createWochenplanZuordnungForMitarbeiter$Json.PATH = '/v1/mitarbeiter/{mitarbeiterId}/wochenplaene';
